import { Outlet } from "react-router";

import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

const ScansLayout = () => {
  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Cloud scanning · ${accountName}`);

  return <Outlet />;
};

export default ScansLayout;
